// @ts-nocheck
import { useRouteMatch } from '@shared/core';
import { createTelemetryObject, createTelemetry } from '@shared/core/analytics';
import { useMemo } from 'react';
import { useCatalogContext, deriveTelemetryPage } from '../Catalog';
import type { GiftBasketTab } from './RegistryGiftBasketWidget.types';

const category = 'shop';
const adminShopPagePrefix = 'admin';
const publicShopPagePrefix = 'newmarketing';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const createObjectWithPagePrefix = (target: {}, source: any[]) => {
  if (typeof source[source.length - 1] === 'object') {
    return Object.assign(target, ...source);
  }

  return target;
};

type RedirectToManageRegistryClickArgs = {
  label: GiftBasketTab;

  method: 'topNav' | 'giftBasketDialog';
};

type GiftBasketClickArgs = {
  overlay: 'toOpen' | 'toClose';
  label: GiftBasketTab;
  method: 'topNav' | 'giftBasketDialog' | 'queryParam';
};

type GiftBasketToggleClickArgs = {
  label: GiftBasketTab;
};

export const catalogRegistryTelemetry = createTelemetryObject({
  actions: {
    redirectToManageRegistryClick: (clickInfo: RedirectToManageRegistryClickArgs, ...args) =>
      createObjectWithPagePrefix(
        {
          category,
          action: 'RegistryNav',
          actionType: 'click',
          extraInfo: {
            ...clickInfo,
          },
        },
        args,
      ),
    giftBasketClicked: (clickInfo: GiftBasketClickArgs, ...args) =>
      createObjectWithPagePrefix(
        {
          category,
          action: 'GiftBasket',
          actionType: 'click',
          extraInfo: {
            ...clickInfo,
          },
        },
        args,
      ),
    giftBasketToggleClicked: (clickInfo: GiftBasketToggleClickArgs, ...args) =>
      createObjectWithPagePrefix(
        {
          category,
          action: 'GiftBasketToggle',
          actionType: 'click',
          extraInfo: {
            ...clickInfo,
          },
        },
        args,
      ),
  },
  pages: {},
});

const { TelemetryProvider, useTelemetry } = createTelemetry(catalogRegistryTelemetry, { eventId: '', section: '' });
const useRegistryGiftBasketWidgetTelemetry = (...args: Parameters<typeof useTelemetry>) => {
  const adminRouteMatch = useRouteMatch<{ eventHandle: string; subRoute: string }>('/:eventHandle/edit/registry/:subRoute');
  const telem = useTelemetry(...args);
  const { selectedCategory } = useCatalogContext();

  const { derivedPage, pagePrefix, categoryOverride } = useMemo(() => {
    const derivedPage = deriveTelemetryPage({ selectedCategory, product: null, view: 'searchBar' });
    const pagePrefix = adminRouteMatch ? adminShopPagePrefix : publicShopPagePrefix;
    const categoryOverride = adminRouteMatch ? `registry.${adminRouteMatch.params.subRoute}` : category;
    return {
      derivedPage,
      pagePrefix,
      categoryOverride,
    };
  }, [adminRouteMatch, selectedCategory]);

  return useMemo(() => {
    const { updateContext, context, ...analyticFnsMap } = telem;
    const updatedTelemObject = { updateContext, context } as typeof analyticFnsMap & { updateContext: typeof updateContext; context: typeof context };
    Object.keys(analyticFnsMap).forEach(key => {
      if (typeof analyticFnsMap[key] === 'object') {
        updatedTelemObject[key] = {};

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        updatedTelemObject[key]['enter'] = (...args: any[]) => analyticFnsMap[key]['enter'](...args, { pagePrefix, eventId: context?.eventId, category: categoryOverride });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        updatedTelemObject[key]['exit'] = (...args: any[]) => analyticFnsMap[key]['exit'](...args, { pagePrefix, eventId: context?.eventId, category: categoryOverride });
      } else {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        updatedTelemObject[key] = (...args: any[]) => analyticFnsMap[key](...args, { page: derivedPage, pagePrefix, eventId: context?.eventId, category: categoryOverride });
      }
    });
    return updatedTelemObject;
  }, [telem, pagePrefix, categoryOverride, derivedPage]);
};

export { TelemetryProvider as RegistryGiftBasketWidgetTelemetryProvider, useRegistryGiftBasketWidgetTelemetry };
